export default __webpack_public_path__ + "static/media/slogan.b5ec0770.png";